import { h, render } from 'preact'
import App from './App'

import '@sodra/bongo-ui/default.css'
import './index.css'

render(<App />, document.body)
